import {randomString} from './global';
import * as backdrop from '../utils/backdrop';
import scrollLock from '../utils/scrollLock';

/**
 * 開閉機能の初期化
 *
 * @param  {HTMLElement}  ctrl    コントロールボタンの要素
 * @param  {HTMLElement}  content コンテンツ部分の要素
 * @param  {String}  idPrefix     idの接頭辞
 * @param  {Boolean} isOpen       開けた状態にするか否か
 * @return {Void}
 */
export const init = (ctrl, content, idPrefix, isOpen) => {
    const idName = content.id || randomString(idPrefix);

    // コンテンツにidがなければ付与
    if (!content.id) {
        content.id = idName;
    }

    // button要素以外にはbutton roleを追加
    if (ctrl.tagName.toLowerCase() !== 'button') {
        ctrl.setAttribute('role', 'button');
        ctrl.tabIndex = 0;
    }

    ctrl.setAttribute('aria-expanded', `${isOpen}`);
    ctrl.setAttribute('aria-controls', idName);
    content.hidden = !isOpen;
};

/**
 * 開く処理
 *
 * @param  {HTMLElement}  ctrl       コントロールボタンの要素
 * @param  {HTMLElement}  content    コンテンツ部分の要素
 * @param  {Boolean} displayBackdrop 背景レイヤーをの制御が必要か否か
 * @return {Boolean}                 コンテンツにtransition-durtionが設定されているか否か
 */
export const open = (ctrl, content, displayBackdrop) => {
    const duration = window.getComputedStyle(content).getPropertyValue('transition-duration');

    content.hidden = false;
    content.style.height = '0';
    content.style.height = `${Math.max(content.offsetHeight, content.scrollHeight)}px`;
    ctrl.setAttribute('aria-expanded', 'true');

    // 背景レイヤーをの制御が必要 かつ 背景レイヤーが存在する場合
    if (displayBackdrop && backdrop !== null) {
        backdrop.displayBackdropLayer(true, content.id);
        scrollLock(true);
    }

    content.focus();

    // transition-durationの有無を返却
    return !(duration === '' || parseFloat(duration) === 0);
};

/**
 * [description]
 * @param  {HTMLElement}  ctrl       コントロールボタンの要素
 * @param  {HTMLElement}  content    コンテンツ部分の要素
 * @param  {Boolean} hiddenBackdrop  背景レイヤーをの制御が必要か否か
 * @return {Boolean}                 コンテンツにtransition-durtionが設定されているか否か
 */
export const close = (ctrl, content, hiddenBackdrop) => {
    const duration = window.getComputedStyle(content).getPropertyValue('transition-duration');

    content.style.height = `${content.clientHeight}px`;
    content.style.height = `${Math.min(content.offsetHeight, 0)}`;
    ctrl.setAttribute('aria-expanded', 'false');

    // 背景レイヤーをの制御が必要 かつ 背景レイヤーが存在する場合
    if (hiddenBackdrop && backdrop !== null) {
        backdrop.displayBackdropLayer(false);
        scrollLock(false);
    }

    ctrl.focus();

    // transitionの有無を返却
    return !(duration === '' || parseFloat(duration) === 0);
};

/**
 * トランジション後の処理
 * @param  {HTMLElement} element トランジションが発生した要素
 * @return {Void}
 */
export const transitionAfter = (element) => {
    // 閉じる操作だった場合
    if (parseInt(element.style.height, 10) === 0) {
        element.hidden = true;
    }

    element.style.height = '';
};
